export default __webpack_public_path__ + "static/media/loginImage.d5412eed.jpg";